"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Deadline = function (props) {
    var classes = ['Deadline'];
    if (props.urgency) {
        var prefix = "Deadline--";
        classes.push(prefix.concat(props.urgency));
    }
    return (React.createElement("time", { className: classes.join(" ") }, props.date));
};
exports.default = Deadline;
